<template>
  <div class="container">
    <titular />
    <div class="row mb-5">
      <div class="col">
        <form class="form-inline" @submit.prevent="listarFilas">
          <div class="btn-group btn-group-toggle mb-2 mr-sm-2" data-toggle="buttons">
            <label class="btn btn-secondary" :class="{ disabled: loading.filtrado, active: tipoRango == tipoRangos[0] }" title="Últims 12 mesos" v-tooltip><input type="radio" name="options" :value="tipoRangos[0]" v-model="tipoRango" /> LTM</label>
            <label class="btn btn-secondary" :class="{ disabled: loading.filtrado, active: tipoRango == tipoRangos[1] }" title="Enguany" v-tooltip><input type="radio" name="options" :value="tipoRangos[1]" v-model="tipoRango" /> YTD</label>
            <label class="btn btn-secondary" :class="{ disabled: loading.filtrado, active: tipoRango == tipoRangos[2] }" title="Últim mes disponible" v-tooltip><input type="radio" name="options" :value="tipoRangos[2]" v-model="tipoRango" /> LMA</label>
          </div>
          <div class="input-group mb-2 mr-sm-2">
            <div class="input-group-prepend">
              <div class="input-group-text">Inici</div>
            </div>
            <input type="date" class="form-control" v-model="rango_inicio" :max="rango_fin" required />
          </div>
          <div class="input-group mb-2 mr-sm-2">
            <div class="input-group-prepend">
              <div class="input-group-text">Fi</div>
            </div>
            <input type="date" class="form-control" v-model="rango_fin" :min="rango_inicio" :max="rango_max" required />
          </div>
          <div class="input-group mb-2 mr-sm-2">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fas fa-user" title="Treballador" v-tooltip></i></div>
            </div>
            <select class="custom-select" v-model="trabajador_escogido">
              <option value="" class="font-weight-bold">Treballador</option>
              <option v-for="(trabajador, index) in trabajadores" :key="index" :value="trabajador.id">{{ trabajador.nombre_completo }}</option>
            </select>
          </div>
          <button type="submit" class="btn btn-primary mb-2 mr-1" :disabled="loading.filtrado"><i-submit icono="fa-angles-right" :loading="loading.filtrado" />Filtrar</button>
          <button type="reset" class="btn btn-secondary mb-2 ml-auto" @click="reiniciarFilas"><i class="fas fa-backspace mr-1"></i>Reiniciar</button>
        </form>
      </div>
    </div>
    <template v-if="esFiltrado">
      <table v-if="filas.length" class="table table-striped table-hover">
        <thead>
          <tr>
            <th scope="col">Projecte</th>
            <th ref="colHoras" class="text-center" scope="col">Hores dedicació</th>
            <th ref="colPc" class="text-center" scope="col">Percentatge total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(fila, index) in filasSuperiores" :key="index">
            <th scope="row" class="d-flex align-items-center"><span class="mr-1">{{ fila.proyecto }} → {{ fila.cliente }}</span><i v-if="tienePresupuesto(fila.prevision)" class="fa-solid fa-circle ml-auto" :class="clasePeligrosidad(fila.prevision)" title="Nivell d'ús de recursos" v-tooltip></i></th>
            <td class="text-center">{{ Math.round(fila.total) }}</td>
            <td class="text-center">{{ Math.round(fila.porcentaje) }}%</td>
          </tr>
          <tr v-if="filasInferiores.length" class="bg-light desplegable-inferior" data-toggle="collapse" data-target="[data-collapse='inferiores']" role="button">
            <th class="text-center" scope="row"><i class="fa-solid fa-caret-right"></i> Fins a {{ limiteInferior }} hores</th>
            <td class="text-center">{{ Math.round(filasInferioresTotal) }}</td>
            <td class="text-center">{{ Math.round(filasInferioresPorcentaje) }}%</td>
          </tr>
          <tr v-if="filasInferiores.length">
            <td colspan="3" class="w-100 p-0">
              <div class="collapse" data-collapse="inferiores">
                <table class="w-100">
                  <tr v-for="(fila, index) in filasInferiores" :key="index">
                    <th scope="row" class="d-flex align-items-center"><span class="mr-1">{{ fila.proyecto }} → {{ fila.cliente }}</span><i v-if="tienePresupuesto(fila.prevision)" class="fa-solid fa-circle ml-auto" :class="clasePeligrosidad(fila.prevision)" title="Nivell d'ús de recursos" v-tooltip></i></th>
                    <td class="text-center" :style="styleHoras">{{ Math.round(fila.total) }}</td>
                    <td class="text-center" :style="stylePc">{{ Math.round(fila.porcentaje) }}%</td>
                  </tr>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr v-for="(total, index) in totales_tipo" :key="index">
            <td class="text-right">Total {{ index }}</td>
            <td class="text-center">{{ Math.round(total) }}</td>
            <td class="text-center">{{ Math.round(porcentajes_tipo[index]) }}%</td>
          </tr>
          <tr class="font-weight-bold">
            <td class="text-right">Total</td>
            <td class="text-center">{{ Math.round(total) }}</td>
            <td></td>
          </tr>
        </tfoot>
      </table>
      <p v-else class="lead">No hi ha hores en la selecció realitzada.</p>
    </template>
    <template v-else>
      <vacio>Utilitza el formulari superior per a fer una selecció.</vacio>
    </template>
  </div>
</template>
    
<script>
import { obtenerNivelPeligrosidadRecursos } from "@/utils/projectStats";

export default {
  name: "ResumPeriodeHores",
  inject: ["formatearDecimales", "rangoInicioLTM", "rangoFinLTM", "rangoInicioYTD", "rangoFinYTD"],
  data() {
    return {
      loading: {
        filtrado: false,
      },
      tipoRango: "",
      tipoRangos: ["LTM", "YTD", "LMA"],
      filas: [],
      totales_tipo: {},
      porcentajes_tipo: {},
      total: 0,
      trabajador_escogido: "",
      trabajadores: [],
      rango_inicio: null,
      rango_fin: null,
      esFiltrado: false,
      limiteInferior: 2,
      widthHoras: null,
      widthPc: null,
      rangoInicioLMA: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 2).toISOString().split("T")[0],
      rangoFinLMA: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split("T")[0],
    };
  },
  computed: {
    rango_max: function () {
      let date = new Date();

      date.setDate(date.getDate());

      return this.toDateISOString(date);
    },
    filasSuperiores: function () {
      return this.filas.filter((a) => Math.round(parseFloat(a.total)) > this.limiteInferior);
    },
    filasInferiores: function () {
      return this.filas.filter((a) => Math.round(parseFloat(a.total)) <= this.limiteInferior);
    },
    filasInferioresTotal: function () {
      return this.filasInferiores.reduce((prev, now) => prev + parseFloat(now.total), 0);
    },
    filasInferioresPorcentaje: function () {
      return this.filasInferiores.reduce((prev, now) => prev + parseFloat(now.porcentaje), 0);
    },
    styleHoras: function () {
      return {
        width: this.widthHoras ? `${this.widthHoras}px` : "auto",
      };
    },
    stylePc: function () {
      return {
        width: this.widthPc ? `${this.widthPc}px` : "auto",
      };
    },
  },
  mounted() {
    this.$http.get("api/treballadors?activos&order=nom").then((response) => {
      this.trabajadores = response.data;
    });
  },
  methods: {
    clasePeligrosidad(prevision) {
      return `peligrosidad-${obtenerNivelPeligrosidadRecursos(prevision)}`;
    },
    tienePresupuesto(prevision) {
      return prevision && prevision.totales_costes && parseFloat(prevision.totales_costes.prevision) > 0;
    },
    reiniciarFilas: function () {
      this.filas = [];
      this.total = 0;
      this.totales_tipo = {};
      this.porcentajes_tipo = {};
      this.esFiltrado = false;
    },
    toDateISOString: function (date) {
      return date.toISOString().split("T")[0];
    },
    listarFilas: function () {
      this.esFiltrado = true;
      this.$http.get(`api/dedicacions?${new URLSearchParams({ resumen: true, fecha_inicio: this.rango_inicio, fecha_fin: this.rango_fin, trabajador_escogido: this.trabajador_escogido })}`).then((response) => {
        this.filas = response.data;
      });
    },
    comprobarRango() {
      switch (true) {
        case this.rango_inicio == this.rangoInicioLTM && this.rango_fin == this.rangoFinLTM:
          this.tipoRango = this.tipoRangos[0];
          break;
        case this.rango_inicio == this.rangoInicioYTD && this.rango_fin == this.rangoFinYTD:
          this.tipoRango = this.tipoRangos[1];
          break;
        case this.rango_inicio == this.rangoInicioLMA && this.rango_fin == this.rangoFinLMA:
          this.tipoRango = this.tipoRangos[2];
          break;
      }
    },
  },
  watch: {
    filas: function (value) {
      this.total = value.reduce((a, b) => a + parseFloat(b.total), 0);
      this.totales_tipo = {};
      this.porcentajes_tipo = {};

      value.forEach((element) => {
        this.totales_tipo[element.tipus] = (this.totales_tipo[element.tipus] ?? 0) + parseFloat(element.total);
        this.porcentajes_tipo[element.tipus] = ((this.totales_tipo[element.tipus] ?? 0) * 100) / this.total;
      });

      value.forEach((element) => {
        element.porcentaje = (parseFloat(element.total) * 100) / this.total;
      });

      this.$nextTick(() => {
        this.widthHoras = this.$refs.colHoras.clientWidth;
        this.widthPc = this.$refs.colPc.clientWidth;
      });
    },
    rango_fin() {
      this.comprobarRango();
    },
    rango_inicio() {
      this.comprobarRango();
    },
    tipoRango(value) {
      switch (value) {
        case "LTM":
          this.rango_inicio = this.rangoInicioLTM;
          this.rango_fin = this.rangoFinLTM;
          break;
        case "YTD":
          this.rango_inicio = this.rangoInicioYTD;
          this.rango_fin = this.rangoFinYTD;
          break;
        case "LMA":
          this.rango_inicio = this.rangoInicioLMA;
          this.rango_fin = this.rangoFinLMA;
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.peligrosidad-success {
  color: var(--success) !important;
}
.peligrosidad-warning {
  color: var(--warning) !important;
}
.peligrosidad-orange {
  color: var(--orange) !important;
}
.peligrosidad-danger {
  color: var(--danger) !important;
}
</style>